import { render, staticRenderFns } from "./ModalPause.vue?vue&type=template&id=99e94aa0&"
import script from "./ModalPause.vue?vue&type=script&lang=js&"
export * from "./ModalPause.vue?vue&type=script&lang=js&"
import style0 from "./ModalPause.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports